import {lightTheme, darkTheme} from '@syndustry/common/js/theme';
import { security } from '@syndustry/common/js/security/Security';

// routing
import Routing from 'public/bundles/fosjsrouting/js/router.min.js';
import routingData from 'public/js/fos_js_routes.json';
Routing.setRoutingData(routingData);

// locales and translations
import locales from 'public/js/translations/locales.json';
import Translator from 'bazinga-translator';
import 'public/js/translations/config.json';
locales.forEach((locale) => {
    Translator.fromJSON(require("public/js/translations/" + locale + ".json"))
});

// load moment localization
// Moment uses 'nb' for Norwegian Bokmål; our app uses 'no'
const momentLocaleMap = { no: 'nb' };
locales.filter((locale) => locale !== 'en').forEach((locale) => {
    require('moment/locale/' + (momentLocaleMap[locale] || locale) + '.js');
});

// plugins & vendors
import flatpickrLocales from "flatpickr/dist/l10n";
import flatpickr from "flatpickr";
import moment from 'moment-timezone';
import jsErrorLog from '@syndustry/infra/js/lib/jsErrorLog';

import {
    Chart as ChartJS,
    Colors,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
ChartJS.register(ArcElement, Tooltip, Legend);

// our own components
import Notifications from '@syndustry/common/js/widgets/notifications';
import ImageLoader from '@syndustry/common/js/widgets/image';
import Notyf from '@syndustry/common/js/widgets/notyf';
import Form from '@syndustry/common/js/widgets/form';
import List from '@syndustry/common/js/widgets/list';
import Modal from '@syndustry/common/js/widgets/modal';
import Hotkeys from '@syndustry/common/js/widgets/hotkeys';
import SessionRenewal from '@syndustry/common/js/widgets/sessionRenewal';

let locale = document.body.getAttribute('data-syn-locale');
let tz = document.body.getAttribute('data-syn-timezone');

// Moment & Flatpickr localization
// Override English date format from US (MM/DD/YYYY) to international (DD/MM/YYYY)
moment.updateLocale('en', {
    longDateFormat: {
        LT:   'HH:mm',
        LTS:  'HH:mm:ss',
        L:    'DD/MM/YYYY',
        LL:   'D MMMM YYYY',
        LLL:  'D MMMM YYYY HH:mm',
        LLLL: 'dddd, D MMMM YYYY HH:mm',
    }
});
moment.locale(momentLocaleMap[locale] || locale);
moment.tz.setDefault(tz);
flatpickr.localize(flatpickrLocales[locale]);

export default {
    name :          'Syndustry',
    scope:          document,
    route:          null,
    route_params:   [],
    locales:        [],
    locale:         locale,
    timezone:       tz,
    security:       security,
    libs:           {
        Moment:     moment,
        Flatpickr:  flatpickr,
    },

    init() {
        this.initErrorLog();

        let body            = document.body;
        this.user           = body.getAttribute('data-syn-user');
        this.route          = body.getAttribute('data-syn-route');
        this.route_params   = JSON.parse(body.getAttribute('data-syn-route-params'));
        this.locales        = JSON.parse(body.getAttribute('data-syn-locales'));
        this.locale         = body.getAttribute('data-syn-locale');
        this.timezone       = body.getAttribute('data-syn-timezone');

        // set the proper theme and handle images
        this.theme = body.getAttribute('data-theme') === 'dark' ? darkTheme : lightTheme;

        // Theme for vendors too
        ChartJS.defaults.color = this.theme['gray-700'];

        // expose and init components
        Syn.libs.Notyf          = Notyf.init();
        Syn.libs.ImageLoader    = ImageLoader.init();
        Syn.libs.Hotkeys        = Hotkeys; // init() is called via a <script>
        Syn.libs.Modal          = Modal.init();
        Syn.libs.Form           = Form.init();
        Syn.libs.List           = List.init();
        Syn.libs.Notifications  = Notifications.init();
        Syn.libs.SessionRenewal = SessionRenewal;
        SessionRenewal.start();

        // Pre-fetch security profile if not cached (non-blocking)
        if (this.user && !this.security.isLoaded()) {
            this.security.load();
        }
    },

    // @todo - do we need a mechanism to re-apply some js?
    // reflow(scope) {
    //     Form.reflow(scope);
    // },

    generateURL(route, params = {}) {
        if(this.locales.length > 1 && !Routing.routes_.hasOwnProperty(route)) {
            var locale = this.locale;
            try {
                if(Syndustry.route_params['_locale'])
                {
                    locale = Syndustry.route_params['_locale'];
                }
            } catch(err) {}

            route = locale + '__RG__' + route;
        }

        return Routing.generate(route, params)
    },

    initErrorLog() {
        if(Routing.routes_.hasOwnProperty('syndustry_infra_exception_jserror')) {
            if( document.readyState !== 'loading' ) {
                jsErrorLog.url = this.generateURL('syndustry_infra_exception_jserror');
            } else {
                document.addEventListener('DOMContentLoaded', function () {
                    jsErrorLog.url = this.generateURL('syndustry_infra_exception_jserror');
                });
            }
        }
    },

    trans(key, params, domain) {
        return Translator.trans(key, params, domain);
    },

    addToast(message, type = 'info', icon = null, duration = 3500, x = 'right', y = 'bottom') {
        Syn.libs.Notyf.open({
            duration:   duration,
            type:       type,
            message:    message,
            icon:       (icon ? '<i class="fa ' + icon + '"</i>' : ''),
            position: {
                x: x,
                y: y
            }
        });
    },

    camelToSnake(key) {
        var result = key.replace( /([A-Z])/g, " $1" );
        return result.split(' ').join('_').toLowerCase();
    },
};